import { GetVehicleResponse } from '../../app/features/vehicles/domain/vehicle.model';
import { MroStatus } from '../../app/features/vehicles/infrastructure/enums/mro-status.enum';
import { MROType } from '../../app/features/vehicles/infrastructure/enums/mro-type.enum';
import { ReadingType } from '../../app/features/vehicles/infrastructure/enums/reading-type.enum';
import { VehicleReason } from '../../app/features/vehicles/infrastructure/enums/vehicle-reasons.enum';
import { VehicleStatus } from '../../app/features/vehicles/infrastructure/enums/vehicle-status.enum';

export const getVehicleResponseMock: GetVehicleResponse = {
        id: "c7662d8a-0eaf-4127-b43c-d9e9d7657b62",
        status: {
            name: VehicleStatus.ENROLLED,
            reason: VehicleReason.NON_COMPLIANT,
            dateTime: "2025-06-18T07:35:38.757982Z"
        },
        vin: "WA1BNAFY3K2028356",
        make: "AUDI",
        model: "Q5",
        year: 2019,
        selectedAddressId: "5267fcf4-a471-46da-9830-da6733909adf",
        mroType: MROType.ODOMETER_CAPTURE,
        selectedModel: {
            id: 41043,
            make: "Audi",
            baseModel: "SQ5",
            model: "SQ5",
            year: 2019,
            summary: "Audi SQ5 2019",
            description: "3.0 L All-Wheel Drive, 6 cyl, Automatic (S8), SIDI, Premium Gasoline",
            displacement: {
                value: 3.0,
                unit: "L"
            },
            drive: {
                code: "AWD",
                description: "All-Wheel Drive"
            },
            cylinders: {
                value: 6,
                unit: "cyl"
            },
            transmission: {
                value: "Automatic (S8)"
            },
            engineDescription: {
                value: "SIDI"
            },
            fuelType: {
                primary: "Premium Gasoline",
                secondary: "Premium Gasoline"
            }
        },
        availableModels: [],
        addressData: {
            id: "5267fcf4-a471-46da-9830-da6733909adf",
            alias: "Trabajo",
            address: "Calle Ribera",
            address2: "del Loira",
            zipCode: "28001",
            city: "Madrid",
            county: "",
            country: "USA",
            state: {
                name: "Oregon",
                code: "OR"
            }
        },
        mroData: {
            id: "ea9c18af-46fc-443f-9f33-25e407824c57",
            status: {
                name: MroStatus.ACTIVATED,
                reason: null,
                dateTime: "2025-06-18T07:35:38.729898185Z"
            },
            initialMilesReading: {
                reportingPeriodId: null,
                readingType: ReadingType.INITIAL_READING,
                miles: 10000.0,
                readingDate: "2025-06-18T07:35:38.679032Z",
                readingPeriodStartDate: null,
                readingPeriodEndDate: null,
                incrementMiles: null
            },
            lastMilesReading: null,
            finalMilesReading: null,
            createdAt: "2025-06-18T07:35:38.668411Z",
            updatedAt: "2025-06-18T07:35:38.729900433Z"
        }
};
